import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { SendOtpApi, SendOtpApi_extrareducer } from './send-otp/index';

const initialState = {
  sendOtpApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const SendOtpSlice = createSlice({
  name: 'sendOtp',
  initialState,
  extraReducers: {
    ...SendOtpApi_extrareducer,
  },
});

export function useSendOtpStore() {
  const sendOtpApiState = useSelector((state) => state.sendOtp.sendOtpApiState);

  const dispatch = useDispatch();

  return {
    sendOtpApiState,
    SendOtpApi: (payload) => dispatch(SendOtpApi(payload)),
  };
}

export default SendOtpSlice.reducer;
